/* ============================================================================
   hh-collection.js — the collection page's behaviors.
   File: assets/hh-collection.js · v4 · 2026-09-28 (America/Los_Angeles), RT-775: P77 RT-771 section 2 (focus
   fallbacks when the grid empties: the layout-box test on the starting control, the Filter button at 993px and
   below or the first enabled box at 994px and up, then the Sort select; the in-view step for every target).
   v3 2026-09-28, RT-766: P77 RT-764 sections 1
   (the anchor), 8 (focus in replaced content), 10 (Clear and "remove all" in place, sort kept) and 11
   (the foot bar at 993px and below).
   v2 2026-09-27, RT-757: a filter or sort choice updates the products in place (P35 F-03, P77 RT-743
   section 3 option A, owner D192-3). v1 2026-07-27.

   THE PAGE WORKS WITH JAVASCRIPT OFF. The facet rail and the sort control are real GET forms
   with real submit buttons inside <noscript>, so this file only removes steps: it updates the
   results in place on a choice and it opens the rail as a section below 994px. Nothing here is
   the only way to reach anything.

   NO [hidden] ANYWHERE. The rail is toggled with a class, because [hidden] is the weakest rule
   in the user-agent stylesheet and any display declaration beats it. That is the defect that put
   a reserved navigation item on screen on 2026-07-26 while the markup, the setting and the
   verifier all reported it hidden (P33-ADR-018).
   ============================================================================ */
(function () {
  'use strict';

  var root = document.querySelector('.hh-col');
  if (!root) return;

  /* --- 1. the Filter sheet, below 900px ----------------------------------- */
  var toggle = root.querySelector('[data-hh-filter-toggle]');
  var rail = document.getElementById('hh-col-rail');
  if (toggle && rail) {
    /* THE FIRST MATCHING ELEMENT IS NOT THE FIRST FOCUSABLE ONE (fixed RT-190).
       This used to take rail.querySelector('input, select, button, a'), which is the first element
       that MATCHES, disabled or not. A zero-count facet value is deliberately rendered `disabled`
       rather than hidden, so the rail does not change shape underneath the customer as they filter.
       When the very first value in the first family happens to have a zero count, that selector
       returned a DISABLED checkbox, .focus() on it did nothing at all, and focus silently stayed on
       the Filter button. Escape then did not work either, because the handler below was bound to the
       rail and the keystroke was landing on the button, OUTSIDE it: the sheet became a keyboard trap
       that could be opened and not closed.
       It is data-dependent, which is why it passed for weeks: whether value one of family one has a
       zero count is a property of the catalog on the day. Availability is currently that value on a
       type page. Skipping anything unfocusable is the fix, and offsetParent catches the A2-2 cap's
       display:none options as well, which the old selector would also have tried to focus. */
    function firstFocusable(container) {
      var candidates = container.querySelectorAll(
        'input:not([type="hidden"]), select, button, a[href], [tabindex]');
      for (var i = 0; i < candidates.length; i++) {
        var el = candidates[i];
        if (el.disabled) continue;
        if (el.offsetParent === null) continue;   // display:none, or an ancestor is
        return el;
      }
      return null;
    }

    toggle.addEventListener('click', function () {
      var open = rail.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        // Move focus into the sheet the tap just opened. Without this the next Tab continues
        // from the button and walks the whole grid before reaching the filters.
        var first = firstFocusable(rail);
        if (first) first.focus();
      }
    });

    /* Escape closes it and hands focus back to the control that opened it, which is the same
       contract the drawer honours.
       BOUND TO THE TOGGLE AS WELL AS THE RAIL, since RT-190. Binding it only to the rail assumed
       focus had reached the rail, so the one case where focus placement fails was also the one case
       where the escape hatch was gone. The two paths cannot disagree: they call one function, and it
       is idempotent because it returns unless the sheet is open. */
    function closeOnEscape(event) {
      if (event.key !== 'Escape') return;
      if (!rail.classList.contains('is-open')) return;
      rail.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.focus();
    }
    rail.addEventListener('keydown', closeOnEscape);
    toggle.addEventListener('keydown', closeOnEscape);
  }

  /* --- 3. "Show all (N)" on a long facet family (P77 A2-2) ------------------ */
  /* The button is type="button", so clicking it never reaches the facet form's change handler
     below and never reloads the page. The hidden group is toggled with a CLASS against a
     display:none rule, never with [hidden], which .hh-col__opts's own display:grid would beat.
     With JavaScript off the button is not rendered at all and every option is visible: see the
     noscript block in snippets/hh-facet-rail.liquid. */
  Array.prototype.forEach.call(root.querySelectorAll('[data-hh-facet-toggle]'), function (btn) {
    btn.addEventListener('click', function () {
      var group = document.getElementById(btn.getAttribute('aria-controls'));
      if (!group) return;
      var open = group.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open
        ? (btn.getAttribute('data-hh-less') || 'Show fewer')
        : (btn.getAttribute('data-hh-more') || 'Show all');
    });
  });

  /* --- 2 and 4. RT-757 (P35 F-03, P77 RT-743 section 3 option A, owner D192-3): a filter or sort
     choice updates the products IN PLACE. It replaces the old "submit the form on change".
     Dawn 16.0.0's assets/facets.js is not reused: it is bound to Dawn's own markup
     (#ProductGridContainer, #ProductCount) and is loaded only by main-collection-product-grid and
     main-search (measured 2026-09-27). This is the H&H section's own fetch-and-replace through the
     Section Rendering API (?section_id=).
     THE CONTRACT (P77): focus is never moved; the focused control is never replaced, removed or
     disabled; the rail DOM and the Sort select are never replaced; no scroll call; the new count
     is spoken once through one polite status region; the address bar carries the choice
     (replaceState). A failed request falls back to a plain navigation to the same URL, so a
     customer is never stuck; an aborted request (a newer choice) is not a failure. With
     JavaScript off none of this runs and the noscript submit buttons work as before.
     RT-766 (P77 RT-764, owner D192-3): THREE NAMED EXCEPTIONS to "focus is never moved; no scroll call":
     (1) THE ANCHOR (s1): when the swap moves the window's scroll position (the new results made the
     page too short), the control that started the update is put back where it was on the screen:
     at most two instant window scrolls, never the rail's own scrollTop, never a held height.
     (2) FOCUS IN REPLACED CONTENT (s8): if focus was inside the grid or the content after the
     layout, it goes to the same product's card, else the first card, else the control that started
     the update (if it has a layout box), else the Filter button (993px and below) or the first enabled
     box (994px and up), else the Sort select (RT-775, P77 RT-771 s2); preventScroll; then the minimum
     scroll for every target (a target in the sticky rail at 994px and up by the rail's own scrollTop).
     (3) CLEAR IN PLACE (s10): "Clear all filters" and the empty grid's "remove all" clear every
     choice in place, keep the sort and the open list, and move focus to a control at hand.
     Each added step after the swap runs in its own try/catch, so an error there never turns a
     finished in-place update into a reload (RT-766 plan lens M1). */
  var facetForm = root.querySelector('[data-hh-facets]');
  var sortForm = root.querySelector('[data-hh-sort]');
  var sortSelect = sortForm ? sortForm.querySelector('select') : null;
  var sectionId = root.getAttribute('data-hh-section');
  var statusEl = root.querySelector('[data-hh-col-status]');
  var countEl = root.querySelector('.hh-col__count');
  var gridEl = document.getElementById('hh-col-grid');
  var seq = 0, controller = null, lastUrl = null, statusTimer = null, leaving = false;
  var inFlight = false, pendingClear = null;   // RT-766: a Clear whose URL is already on its way (plan lens M2)
  var heldLabel = new WeakMap();   // a focused box's new name, applied when it loses focus
  var CLEAR_SEL = '.hh-col__clear a, .hh-col__empty a.hh-col__emptylink:not(.hh-col__backfirst)';
  window.addEventListener('pagehide', function () { leaving = true; });

  function safe(fn) { try { fn(); } catch (e) {} }

  function choiceUrl() {
    var form = facetForm || sortForm;
    var u = new URL(form ? form.getAttribute('action') : window.location.pathname, window.location.origin);
    var p = new URLSearchParams();
    if (facetForm) {
      new FormData(facetForm).forEach(function (v, k) {
        if (k === 'sort_by') return;
        if (typeof v === 'string' && v.trim() === '') return;
        p.append(k, v);
      });
    }
    if (sortSelect && sortSelect.value) p.set('sort_by', sortSelect.value);
    u.search = p.toString();
    return u;
  }

  /* RT-766 (P77 s10 href): both clear links point at the collection URL with the current sort_by and no
     filter parameters, after every in-place update (a Sort change included). The theme's own render
     does the same in Liquid, so "open in a new tab" and the no-JavaScript path keep the sort. */
  function clearHref() {
    var form = facetForm || sortForm;
    var u = new URL(form ? form.getAttribute('action') : window.location.pathname, window.location.origin);
    var p = new URLSearchParams();
    if (sortSelect && sortSelect.value) p.set('sort_by', sortSelect.value);
    u.search = p.toString();
    return u.pathname + u.search;
  }
  function setClearHrefs() {
    var h = clearHref();
    Array.prototype.forEach.call(root.querySelectorAll(CLEAR_SEL), function (a) {
      if (a.getAttribute('href') !== h) a.setAttribute('href', h);
    });
  }

  function keepSortInFacetForm() {
    if (!facetForm || !sortSelect) return;
    var h = facetForm.querySelector('input[type="hidden"][name="sort_by"]');
    if (!h) {
      h = document.createElement('input'); h.type = 'hidden'; h.name = 'sort_by';
      facetForm.insertBefore(h, facetForm.firstChild);
    }
    h.value = sortSelect.value;
  }

  function keyOf(input) { return input.name + '\u0000' + input.value; }

  function announce(words) {
    if (!statusEl) return;
    if (statusTimer) clearTimeout(statusTimer);
    statusEl.textContent = '';
    // emptied first and filled 100 ms later (an implementation constant, not a design value), so
    // the same words after a second choice are still spoken; a newer update cancels the timer
    statusTimer = setTimeout(function () { statusEl.textContent = words; statusTimer = null; }, 100);
  }

  /* AN ACTIVE VALUE IS ALWAYS VISIBLE (A2-2, snippets/hh-facet-rail.liquid). A reload moves an
     active value out of the "Show all" list; in place, a ticked value in that list is KEPT on
     screen by a class, so "Show fewer" can never hide a filter that is on. Nothing moves in the DOM. */
  function keepTicked() {
    if (!facetForm) return;
    Array.prototype.forEach.call(facetForm.querySelectorAll('.hh-col__opts--more'), function (ul) {
      var any = false;
      Array.prototype.forEach.call(ul.children, function (li) {
        var box = li.querySelector('input[type="checkbox"]');
        var on = !!(box && box.checked);
        li.classList.toggle('is-kept', on);
        if (on) any = true;
      });
      ul.classList.toggle('has-kept', any);
    });
  }

  /* Facet counts are updated as TEXT in place; each box's name is copied from the server's own
     render (one source for the words and the singular rule). A box that falls to 0 stays
     operable: this code removes `disabled` when a count rises and never sets it. */
  function updateFacets(doc) {
    if (!facetForm) return;
    var fresh = new Map();
    var nf = doc.querySelector('[data-hh-facets]');
    if (nf) {
      Array.prototype.forEach.call(nf.querySelectorAll('input[type="checkbox"]'), function (i) {
        var lab = i.closest('label');
        var n = lab ? lab.querySelector('.hh-col__n') : null;
        fresh.set(keyOf(i), { label: i.getAttribute('aria-label'), count: n ? n.textContent : null });
      });
    }
    Array.prototype.forEach.call(facetForm.querySelectorAll('input[type="checkbox"]'), function (i) {
      var f = fresh.get(keyOf(i));
      var lab = i.closest('label');
      var n = lab ? lab.querySelector('.hh-col__n') : null;
      var count = f && f.count !== null ? f.count : '0';   // absent from the new render: 0
      var label = f && f.label ? f.label :
        (i.getAttribute('aria-label') || '').replace(/, \d+ products?$/, ', ' + count + (count === '1' ? ' product' : ' products'));
      if (n && n.textContent !== count) n.textContent = count;
      if (i === document.activeElement) { if (label !== i.getAttribute('aria-label')) heldLabel.set(i, label); }
      else if (label && i.getAttribute('aria-label') !== label) { i.setAttribute('aria-label', label); }
      if (Number(count) > 0 && i.disabled) i.disabled = false;
      if (lab) lab.classList.toggle('is-off', Number(count) === 0 && !i.checked);
    });
    var oldClear = facetForm.querySelector('.hh-col__clear');
    var newClear = nf ? nf.querySelector('.hh-col__clear') : null;
    if (oldClear && !newClear && !oldClear.contains(document.activeElement)) oldClear.parentNode.removeChild(oldClear);
    if (!oldClear && newClear) {
      var ns = null;
      Array.prototype.forEach.call(facetForm.children, function (c) { if (c.tagName === 'NOSCRIPT') ns = c; });
      facetForm.insertBefore(document.importNode(newClear, true), ns);
    }
    keepTicked();
  }

  /* The page line, the pager and the verifier's marker spans sit after the layout: replaced in order. */
  function replaceAfterLayout(doc) {
    var layout = root.querySelector('.hh-col__layout');
    var nlayout = doc.querySelector('.hh-col__layout');
    if (!layout || !nlayout) return;
    var parent = layout.parentNode;
    while (layout.nextSibling) parent.removeChild(layout.nextSibling);
    for (var s = nlayout.nextSibling; s; s = s.nextSibling) parent.appendChild(document.importNode(s, true));
  }

  /* ---- RT-766 helpers ---- */
  function hasBox(e) { return !!(e && e.isConnected && e.getClientRects().length > 0); }
  // the list widths (993px and below) are where the Filter button is rendered (plan lens m7)
  function listWidths() { return !!(toggle && toggle.offsetParent !== null); }
  function headerBottom() {
    var h = document.querySelector('.section-header');
    if (!h) return 0;
    var b = h.getBoundingClientRect().bottom;
    return b > 0 ? b : 0;
  }
  // fully in view below the sticky header, with a 1px tolerance (plan lens m6)
  function fullyInView(e) {
    var r = e.getBoundingClientRect();
    return !(headerBottom() - r.top > 1 || r.bottom - window.innerHeight > 1);
  }
  function jumpTo(y) {
    try { window.scrollTo({ top: y, left: window.scrollX, behavior: 'instant' }); }
    catch (e) { window.scrollTo(window.scrollX, y); }
  }
  function inAfterLayout(e) {
    var layout = root.querySelector('.hh-col__layout');
    if (!layout) return false;
    for (var s = layout.nextSibling; s; s = s.nextSibling) { if (s.nodeType === 1 && s.contains(e)) return true; }
    return false;
  }
  function anyActive() {
    if (!facetForm) return false;
    var on = false;
    Array.prototype.forEach.call(facetForm.querySelectorAll('input[type="checkbox"]'), function (i) { if (i.checked) on = true; });
    Array.prototype.forEach.call(facetForm.querySelectorAll('input[type="number"]'), function (i) { if (i.value.trim() !== '') on = true; });
    return on;
  }
  function firstBox() {
    if (!facetForm) return null;
    var bs = facetForm.querySelectorAll('input[type="checkbox"]');
    for (var k = 0; k < bs.length; k++) {
      var i = bs[k], lab = i.closest('label');
      if (i.disabled || !lab || lab.offsetParent === null) continue;
      return i;
    }
    return null;
  }

  /* s1 THE ANCHOR. `before` is the control's top read right BEFORE the new content went in; `y0` the
     window's scroll position at the same moment. The correction runs only when the swap moved the
     window (the browser clamped a page that got too short: P77 s1's own sentence and its "RT-743
     reading"; the reading is routed to P77 for confirmation, plan lens M3); when nothing moves it
     does nothing. At most two instant scrolls; if a scroll does not move the control (a stuck rail),
     it is undone and the rule stops. */
  function anchorFix(anchor, before, y0) {
    if (before === null || !hasBox(anchor)) return;           // skip: no layout box (P77 s1)
    var d = anchor.getBoundingClientRect().top - before;      // forces layout, so the clamp is in scrollY
    if (Math.abs(window.scrollY - y0) < 1) return;
    for (var k = 0; k < 2; k++) {
      if (k) d = anchor.getBoundingClientRect().top - before;
      if (Math.abs(d) < 1) return;
      var ys = window.scrollY;
      jumpTo(ys + d);
      if (Math.abs(anchor.getBoundingClientRect().top - before - d) < 1) { jumpTo(ys); return; }
    }
  }

  /* s8 FOCUS NEVER FALLS TO THE PAGE (P77 RT-764 s8; the fallbacks (3) to (5) and the in-view step for every
     target are P77 RT-771 s2, built RT-775). Runs after the anchor. A candidate that is connected and has a
     layout box but does not take focus falls to the next one (a recorded reading, routed to P77). */
  function railInView(el) {
    // 994px and up: a target inside the sticky rail is brought into the rail's own visible box, below the sticky
    // header, by the rail's scrollTop, never by a window scroll (P77 RT-771 s2; RT-764 s10). 1px tolerance.
    var lab = el.closest('label') || el, r = lab.getBoundingClientRect(), rr = rail.getBoundingClientRect();
    var top = Math.max(rr.top, headerBottom()), bottom = Math.min(rr.bottom, window.innerHeight);
    if (top - r.top > 1) rail.scrollTop -= (top - r.top);
    else if (r.bottom - bottom > 1) rail.scrollTop += (r.bottom - bottom);
  }
  function focusFix(ae, wasIn, path, anchor) {
    if (!wasIn) return;
    if (ae && ae.isConnected && document.activeElement === ae) return;
    var links = gridEl.querySelectorAll('li.hh-col__card a.hh-col__link'), cands = [], target = null;
    if (path) {
      for (var k = 0; k < links.length; k++) {
        if (new URL(links[k].href).pathname === path) { cands.push(links[k]); break; }   // (1)
      }
    }
    if (links.length) cands.push(links[0]);                                               // (2)
    cands.push(anchor);                                                                   // (3)
    cands.push(listWidths() ? toggle : firstBox());                                       // (4)
    cands.push(sortSelect);                                                               // (5)
    for (var c = 0; c < cands.length; c++) {
      var e = cands[c];
      if (!e || !hasBox(e)) continue;                  // connected and has a layout box
      e.focus({ preventScroll: true });
      if (document.activeElement === e) { target = e; break; }
    }
    if (!target) return;
    if (!listWidths() && rail && rail.contains(target)) railInView(target);
    else if (!fullyInView(target)) target.scrollIntoView({ block: 'nearest' });
  }

  /* s10 CLEAR IN PLACE: after the new content is in place, focus moves to a control at hand, then the
     Clear link is removed, then (only for a target out of view, the empty grid's "remove all") the
     minimum window move. Where focus lands on the foot button, its name carries the count and the
     status region is not written for this one update. */
  function afterClear(words) {
    var target = null, speak = true;
    if (listWidths()) {
      if (rail && rail.classList.contains('is-open') && showBtn) { setFoot(); target = showBtn; speak = false; }
      else target = toggle;
    } else {
      target = firstBox();
    }
    if (!speak && statusTimer) { clearTimeout(statusTimer); statusTimer = null; }   // plan lens m3
    if (target) target.focus({ preventScroll: true });
    var c = facetForm ? facetForm.querySelector('.hh-col__clear') : null;
    if (c && !anyActive()) c.parentNode.removeChild(c);
    if (target && !listWidths() && rail) {
      // 994px and up: the rail is sticky; its own scrollTop brings the box into its visible box
      var lab = target.closest('label') || target, r = lab.getBoundingClientRect(), rr = rail.getBoundingClientRect();
      if (r.top < rr.top) rail.scrollTop -= (rr.top - r.top);
      else if (r.bottom > rr.bottom) rail.scrollTop += (r.bottom - rr.bottom);
    }
    if (target && !fullyInView(target)) target.scrollIntoView({ block: 'nearest' });
    if (speak && words) announce(words);
  }

  function update(opts) {
    opts = opts || {};
    var u = choiceUrl();
    var href = u.pathname + u.search;
    if (href === lastUrl) {                          // the same choice twice (Enter, then blur) sends nothing
      if (opts.clear) {                              // a Clear whose URL is already the last choice (plan lens M2)
        if (inFlight) pendingClear = opts;
        else safe(function () { afterClear(countEl ? countEl.textContent.trim() : ''); });
      }
      return;
    }
    lastUrl = href;
    pendingClear = opts.clear ? opts : null;
    keepSortInFacetForm();
    if (!sectionId || !gridEl || !window.fetch || !window.DOMParser || !window.URL) { window.location.assign(href); return; }
    var mine = ++seq;
    if (controller) controller.abort();
    controller = window.AbortController ? new AbortController() : null;
    inFlight = true;
    gridEl.classList.add('is-loading');
    var fu = new URL(u.toString()); fu.searchParams.set('section_id', sectionId);
    fetch(fu.toString(), { credentials: 'same-origin', signal: controller ? controller.signal : undefined })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (html) {
        if (mine !== seq) return;                    // a newer choice is on its way; it applies instead
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var ngrid = doc.getElementById('hh-col-grid');
        var ncount = doc.querySelector('.hh-col__count');
        if (!ngrid || !ncount) throw new Error('no grid in the response');
        // RT-766: read right BEFORE the new content goes in (P77 s1 record; s8 detection)
        var anchor = opts.clear ? null : (opts.anchor || null);
        var before = null, y0 = window.scrollY, ae = document.activeElement, wasIn = false, path = null;
        safe(function () {
          if (hasBox(anchor)) before = anchor.getBoundingClientRect().top;
          wasIn = !!(ae && ae !== document.body && (gridEl.contains(ae) || inAfterLayout(ae)));
          var a = wasIn && ae.closest ? ae.closest('a[href]') : null;
          if (a) path = new URL(a.href).pathname;
        });
        gridEl.innerHTML = ngrid.innerHTML;
        if (countEl) countEl.textContent = ncount.textContent;
        replaceAfterLayout(doc);
        updateFacets(doc);
        try { window.history.replaceState(window.history.state, '', href); } catch (e) {}
        gridEl.classList.remove('is-loading');
        inFlight = false;
        setFoot();
        var words = ncount.textContent.trim();
        var clearing = pendingClear; pendingClear = null;
        safe(setClearHrefs);
        if (clearing) { safe(function () { afterClear(words); }); return; }
        safe(function () { anchorFix(anchor, before, y0); });
        safe(function () { focusFix(ae, wasIn, path, anchor); });
        announce(words);
      })
      .catch(function (e) {
        if (e && e.name === 'AbortError') return;    // replaced by a newer choice: not a failure
        if (mine !== seq || leaving) return;
        inFlight = false;
        window.location.assign(href);                // the old path: a full load of the same choice
      });
  }

  if (facetForm) {
    facetForm.addEventListener('change', function (event) {
      var t = event.target;
      if (!t || t.type === 'number') return;         // a price field commits on blur or Enter only (P77)
      update({ anchor: t });
    });
    Array.prototype.forEach.call(facetForm.querySelectorAll('input[type="number"]'), function (f) {
      f.addEventListener('blur', function () { update({ anchor: f }); });
      f.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') { event.preventDefault(); update({ anchor: f }); }
      });
    });
    facetForm.addEventListener('focusout', function (event) {
      var t = event.target, l = t && heldLabel.get(t);
      if (l) { t.setAttribute('aria-label', l); heldLabel.delete(t); }
    });
    facetForm.addEventListener('submit', function (event) {
      event.preventDefault();
      var a = document.activeElement;
      update({ anchor: a && facetForm.contains(a) ? a : null });
    });
  }
  if (sortSelect) {
    sortSelect.addEventListener('change', function () { update({ anchor: sortSelect }); });
    sortForm.addEventListener('submit', function (event) { event.preventDefault(); update({ anchor: sortSelect }); });
  }
  lastUrl = (function () { var u = choiceUrl(); return u.pathname + u.search; })();

  /* RT-766 (P77 s10): "Clear all filters" and the empty grid's "remove all" work in place. A plain
     primary click only: a modified click (new tab or window) follows the href, which keeps the sort. */
  root.addEventListener('click', function (event) {
    var a = event.target && event.target.closest ? event.target.closest(CLEAR_SEL) : null;
    if (!a || !root.contains(a)) return;
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (!facetForm || !sectionId || !gridEl || !window.fetch || !window.DOMParser || !window.URL) return;   // the plain navigation
    event.preventDefault();
    Array.prototype.forEach.call(facetForm.querySelectorAll('input[type="checkbox"]'), function (i) { i.checked = false; });
    Array.prototype.forEach.call(facetForm.querySelectorAll('input[type="number"]'), function (i) { i.value = ''; });
    keepTicked();
    update({ clear: true });
  });

  /* THE FOOT BAR (P77: while the filter section is open, wherever the Filter button exists, 993px and
     below since RT-766, P77 RT-764 s11; the CSS shows it only there). Built here, so it does not exist
     with scripts off. Its words are "Show " + the
     toolbar's own count words ("Show 54 products", "Show 1 product"): P77's placeholder words,
     routed to P34 for ratification. The press closes the section, puts focus on Filter, and
     brings the Filter button (by the F-05 scroll margin, under the sticky header) and the grid
     top below it into view. */
  var showBtn = null;
  function setFoot() { if (showBtn && countEl) showBtn.textContent = 'Show ' + countEl.textContent.trim(); }
  if (toggle && rail) {
    var foot = document.createElement('div'); foot.className = 'hh-col__railfoot';
    showBtn = document.createElement('button'); showBtn.type = 'button'; showBtn.className = 'hh-col__showbtn';
    foot.appendChild(showBtn); rail.appendChild(foot); setFoot();
    showBtn.addEventListener('click', function () {
      rail.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.focus({ preventScroll: true });
      toggle.scrollIntoView({ block: 'start' });
    });
  }
})();
